// extracted by mini-css-extract-plugin
module.exports = {"gameList":"GameList_gameList__3sbBv","h2":"GameList_h2__1NZwM"};